$(function() {

    $('*[data-popup-activity]').on('click', function(e) {

        var id = $(this).attr('data-popup-activity');

        var pop = new Esearcher.Popup('aktion_view.php?aktion_id=' + id, 'Aktion');

        pop.show();

        e.preventDefault();
    });
});
